//产品费率
import { axios } from '@/utils/request';
//添加
const addRate = params => {
  return axios({
    url: process.env.VUE_APP_CMS_PRODUCT + '/product/rate/save',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
//编辑
const editRate = params => {
  return axios({
    url: process.env.VUE_APP_CMS_PRODUCT + '/product/productsFundRate/edit',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
export { addRate, editRate };
